var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cold-humidity"},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"diffStoragePowerChartt"}})])
}]

export { render, staticRenderFns }